import { setPageTitle } from '@common';
import React, { useEffect } from 'react';

import './not-found-page.scss';

function NotFoundPage(): JSX.Element {
	
	useEffect(() => {
		setPageTitle('');
	}, []);
	
	return (
		<div className='not_found_error'>
			Такой страницы не существует...
		</div>
	);
}

export {NotFoundPage};